import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import HomePage from './pages/HomePage';
import BlogPost from './pages/BlogPost';
import InvalidRoute from './pages/InvalidRoute';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/*" element={<InvalidRoute />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
